<template>
    <div>
        <div class="w-full md:w-4/5 m-auto py-6 px-4 md:px-12">
            <div v-if="!loading" class="lds-spinner">
                <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
            </div>
            <h1 class="mb-4 text-green-600 text-2xl text-left font-bold text-2xl">
                <router-link :to="{ name: 'ViewApplication' }">Applications</router-link>
                / {{ personalData.first_name }} {{ personalData.last_name }}
            </h1>
            <div class="bg-gray-100 border px-2 py-2 mt-1 pb-6">
                <div class="flex justify-between mb-6 px-8 mt-4 align-baseline text-sm">
                    <div v-if="loading" class="w-full lg:flex text-left">
                        <div class="w-full flex lg:w-1/2">
                            <div>
                                <div>Applicant:</div>
                                <div>Programme:</div>
                                <div>Programme type:</div>
                            </div>
                            <div class="ml-4">
                                <div>{{ personalData.first_name }} {{ personalData.last_name }}</div>
                                <div>{{ firstChoice.programme_title }}</div>
                                <div>{{ firstChoiceType.name }}</div>
                            </div>
                        </div>
                        <div class="w-full flex lg:w-1/2">
                            <div>
                                <div>Academic year:</div>
                                <div>Study mode:</div>
                                <div>Status:</div>
                            </div>
                            <div class="ml-4">
                                <div>{{ firstChoice.sits_ipo_ayrc }}</div>
                                <div>{{ firstChoice.moa_name }}</div>
                                <div>{{ applicationData.public_status }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="loading">
                    <div id="references" class="bg-white border border-gray-300 flex justify-between px-8 mt-1">
                        <h1 class="text-1xl leading-10">Current Choices</h1>
                    </div>
                    <div id="references_content" class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap">
                        <div>
                            <p class="text-left m-4">You need to add another course to your application. If this is a group application, a new application would be created.</p>
                        </div>
                        <programme-details v-if="loading"
                                           :programme-type="applicationData?.programme_code"
                                           :application-data="applicationDetails"
                                           :application-ref="$route.params.id"
                                           :mode-of-attendance="modeOfAttendance"
                                           :programme-data="programmeData.data"
                                           :programme-types-list="programmeTypesList"
                                           :programmes="programmesList['data']"
                                           :proposed-start-dates="proposedStartDates"
                                           :courses="coursesList?.data"
                                           @programmeChange="programmeChange"
                                           @typeChanged="programmeTypeChange"
                        />

                        <div v-if="successMessage" class="m-8 success-message w-full">{{ successMessage }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Referees from './Details/Referees'
import ProgrammeDetails from '@/views/Application/Details/ProgrammeDetails'

export default {
    name: 'EditChoices',
    metaInfo() {
        return {
            title: 'Edit Choices',
        }
    },
    components: {
        // Referees,
        ProgrammeDetails,
    },
    data() {
        return {
            personalDetailsShow: false,
            nationalityShow: false,
            contactDetailsShow: false,
            statementShow: false,
            programmeDetailsShow: true,
            educationDetailsShow: false,
            employmentDetailsShow: false,
            fundingDetailsShow: false,
            referencesShow: false,
            documentationShow: false,
            equalOpportunitiesShow: false,
            contextualAdmissionsShow: false,
            declarationShow: true,
            applicationData: [],
            personalData: {
                first_name: '',
                last_name: '',
            },
            contactData: [],
            priorEducation: [],
            contextualAdmissions: [],
            employmentHistory: [],
            programmeData: [],
            documentation: [],
            documentTypes: [],
            programmes: [],
            sponsorData: [],
            paymentData: [],
            modeOfFunding: 'Applied',
            loading: false,
            genders: [],
            ethnicities: [],
            disabilities: [],
            equalOpportunities: [],
            religiousBelief: [],
            sexualOrientation: [],
            sourcesOfInterest: [],
            sections: [],
            genderIdentity: [],
            modeOfAttendance: [],
            proposedStartDates: [],
            scholarships: [],
            firstChoiceTypeReference: '',
            firstChoiceReference: '',
            nationality: [],
        }
    },
    computed: {
        firstChoiceType: {
            get: function () {
                const programmeTypes = this.$store.getters.programmeTypesList

                if (programmeTypes !== undefined) {
                    if (this.firstChoiceTypeReference !== undefined && this.firstChoiceTypeReference.length > 0) {
                        return programmeTypes.data.filter(programmeType => programmeType['reference'] === this.firstChoiceTypeReference)[0]
                    } else {
                        if (programmeTypes.data.length > 0 && this.$store.getters.applicationDetails['data']['first_choice_type']) {
                            return programmeTypes.data.filter(programmeType => programmeType['reference'] === this.$store.getters.applicationDetails['data']['first_choice_type'])[0]
                        }
                    }
                }
                return {name: '', num_references_required: 2}
            },
            set: function (newValue) {
                this.firstChoiceTypeReference = newValue
            },
        },
        firstChoice: {
            get: function () {
                const programmes = this.$store.getters.programmesList

                if (programmes !== undefined) {
                    if (this.firstChoiceReference !== undefined && this.firstChoiceReference.length > 0) {
                        return programmes.data.filter(programme => programme['reference'] === this.firstChoiceReference)[0]
                    } else {
                        if (programmes.data.length > 0 && this.$store.getters.applicationDetails['data']['first_choice'] !== null) {
                            return programmes.data.filter(programme => programme['reference'] === this.$store.getters.applicationDetails['data']['first_choice'])[0]
                        }
                    }
                }
                return {name: '', programme_title: '', sits_ipo_ayrc: '', moa_name: ''}
            },
            set: function (newValue) {
                this.firstChoiceReference = newValue
            },
        },
        applicationDetails() {
            return this.$store.getters.applicationDetails
        },
        coursesList() {
          return this.$store.getters.coursesList
        },
        programmesList() {
            return this.$store.getters.programmesList
        },
        gendersList() {
            return this.$store.getters.gendersList
        },
        titlesList() {
            return this.$store.getters.titlesList
        },
        sections() {
          return this.$store.getters.sections
        },
        ethnicityList() {
            return this.$store.getters.ethnicityList
        },
        disabilityList() {
            return this.$store.getters.disabilityList
        },
        religiousBeliefList() {
            return this.$store.getters.religiousBeliefList
        },
        sexualOrientationList() {
            return this.$store.getters.sexualOrientationList
        },
        genderIdentityList() {
            return this.$store.getters.genderIdentityList
        },
        documentTypesList() {
            return this.$store.getters.documentTypesList
        },
        sourcesOfInterestList() {
            return this.$store.getters.sourcesOfInterestList
        },
        contactDetailTypesList() {
            return this.$store.getters.contactDetailTypesList
        },
        countriesOfDomicileList() {
            return this.$store.getters.countriesOfDomicileList
        },
        countriesOfBirthList() {
            return this.$store.getters.countriesOfBirthList
        },
        programmeTypesList() {
            return this.$store.getters.programmeTypesList
        },
        modeOfAttendanceList() {
            return this.$store.getters.modeOfAttendanceList
        },
        proposedStartDateList() {
            return this.$store.getters.proposedStartDateList
        },
        scholarshipsList() {
            return this.$store.getters.scholarshipsList
        },
        nationalityList() {
            return this.$store.getters.nationalityList
        },
    },
    watch: {
        applicationDetails(data) {
            this.applicationData = data.data
            this.personalData = data.data.user.data
            this.contactData = data.data.contactDetails.data
            this.programmeData = data.data.applicationProgrammes
            this.priorEducation = data.data.priorEducation.data
            this.employmentHistory = data.data.employmentHistory.data
            this.equalOpportunities = data.data.equalOpportunities.data
            this.documentation = data.data.documents.data
            this.documentTypes = data.data.documentTypes
            this.sponsorData = data.data.applicationSponsors.data
            this.paymentData = data.data.payments.data
            this.loading = true

        },
        programmesList(data) {
            this.programmes = data
        },
        coursesList(data) {
          this.courses = data
        },
        gendersList(data) {
            this.genders = data
        },
        ethnicityList(data) {
            this.ethnicities = data
        },
        disabilityList(data) {
            this.disabilities = data
        },
        religiousBeliefList(data) {
            this.religiousBelief = data
        },
        sexualOrientationList(data) {
            this.sexualOrientation = data
        },
        genderIdentityList(data) {
            this.genderIdentity = data
        },
        documentTypesList(data) {
            this.documentTypes = data
        },
        sourcesOfInterestList(data) {
            this.sourcesOfInterest = data
        },
        modeOfAttendanceList(data) {
            this.modeOfAttendance = data
        },
        proposedStartDateList(data) {
            this.proposedStartDates = data
        },
        scholarshipsList(data) {
            this.scholarships = data
        },
        nationalityList(data) {
            this.nationality = data
        },
    },
    mounted() {
    },
    created() {
        this.loadApplication()

        // pass parameter in url to expand that section on load (eg section=educationDetailsShow). then remove the param
        const expandSection = new URLSearchParams(window.location.search).get('section')
        this[expandSection] = true

        const url = new URL(location)
        url.searchParams.delete('section')
        history.replaceState(null, null, url)
    },
    methods: {
        loadApplication() {
            this.$store.dispatch('retrieveSingleApplication', {
                applicationRef: this.$route.params.id,
            })
        },
        programmeTypeChange(newValue) {
            this.firstChoiceType = newValue
        },
        programmeChange(newValue) {
            this.firstChoice = newValue
        },
        modeOfFundingChange(value) {
            this.modeOfFunding = value
        },
    },
}
</script>
<style scoped>
    table {
        width: 100%;
        border:1px solid #eee;
    }
    table tr {
        border:1px solid #eee;
    }
    table td {
        padding:5px;
        border:1px solid #eee;
    }
    table th {
        padding:5px;
        width:50%;
    }
    @media screen and (min-width: 1201px) {
        table th {
            width:25%;
        }
    }
</style>